import { Button, Typography } from "@material-ui/core"
import { OptionProps, Selected } from "../../../../utils/safetyPlanUtils"
import { colors } from "../../../../utils/theme"
import useSafetyPlanOptionStyles from "./useSafetyPlanOptionStyles"

/**
 * A toggleable option row within the safety plan editor. Clicking it adds or
 * removes the option from the current selection, with a highlighted style when
 * selected.
 *
 * @param option - The `ResponseOption` to display, including its `id` and `response_text`.
 * @param onClick - Callback invoked with `(id, [], type)` when the option is toggled.
 * @param type - The category type string passed back through `onClick`.
 * @param selection - The current list of selected items, used to derive the highlighted state.
 */
export default function SelectAllOption({
  option,
  onClick,
  type,
  selection,
}: OptionProps) {
  const selectedOption = selection.some((el: Selected) => el.id === option.id)

  const classes = useSafetyPlanOptionStyles()
  return (
    <>
      <Button
        id={option.id}
        aria-pressed={selectedOption}
        style={{
          border: selectedOption
            ? `2px solid  ${colors.safetyPlan.ice}`
            : "none",
          background: selectedOption
            ? colors.safetyPlan.cloud
            : "rgba(0, 0, 0, 0.03)",
          textTransform: "none",
          transition: "none",
        }}
        className={classes.optionContainer}
        onClick={() => onClick(option.id, [], type)}
        disableElevation
      >
        <Typography className={classes.optionTxt}>
          {option.response_text}
        </Typography>
      </Button>
    </>
  )
}
